// HTML entities + scraped-title cleanup for tournament names.
// Scraped names from pzbad/tournamentsoftware sometimes carry HTML numeric
// entities (e.g. G&#243;rowska) and trailing site-name suffix.
const PZBAD_SUFFIX = /\s*\|\s*Polski\s+Zwiazek\s+Badmintona\s*$/;
// Scraped pages often start with "Matches - …" or "Wyniki - …" wrappers
// added by the source site's title bar.
const MATCHES_PREFIX = /^(?:Matches|Wyniki)\s*-\s*/i;

export function cleanTournamentName(raw: string | null | undefined): string {
  if (!raw) {
    return '';
  }

  // Normalize whitespace (some scrapes carry \r\n + indentation inside the title).
  let s = raw.replace(/\s+/g, ' ').trim();
  s = s.replace(PZBAD_SUFFIX, '').trim();
  s = s.replace(MATCHES_PREFIX, '');

  // Decode numeric HTML entities (decimal + hex).
  s = s.replace(/&#(\d+);/g, (_, dec) => String.fromCodePoint(parseInt(dec, 10)));
  s = s.replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCodePoint(parseInt(hex, 16)));
  // Common named entities.
  const named: Record<string, string> = {
    amp: '&',
    quot: '"',
    apos: "'",
    lt: '<',
    gt: '>',
    nbsp: ' ',
  };
  s = s.replace(/&([a-z]+);/g, (full, name) => named[name] ?? full);
  return s;
}
